import { LoadingStyle } from '@/imports-files/components/loading';
import LoaderGif from '/public/images/loader/gif_loader.gif';
import Image from 'next/image'
export function Loading(props)
{
    return(
            <div className={`Loader ${LoadingStyle.Loading}`}>
                <div>
                  <Image  src     =  {LoaderGif} 
                          alt     =  "Loader"
                          height  =  {500}
                          width   =   {750}/>
                </div>
            </div>
          )
}
